import React, { useState, useContext, useEffect } from 'react'
import { COLOR } from '../../Color';
import { LoadingOutlined } from '@ant-design/icons'

export default function BaseButton(props) {
    const textColor = props.color === 'white' ? COLOR.text : 'white'
    const outLined = props.outlined;
    const [isLoading, setIsLoading] = useState(false)

    const getBackgroundColor = () => {
        if (props.disabled || isLoading)
            return props.color==='white'?'#FAFAFA':'lightgray';

        switch (props.color) {
            case 'white': return 'white';
            case 'red': return COLOR.danger;
            case 'green': return COLOR.green;
            case 'blue': return COLOR.blue;
            case 'orange': return COLOR.orange;
            case 'clinic': return COLOR.clinic;
            default: return props.color;
        }
    }

    const buttonStyle = {color:'white', fontWeight:700, fontSize:'10pt'}
    if (props.color) {
        buttonStyle.color = outLined ? getBackgroundColor() : textColor;
        buttonStyle.backgroundColor = outLined ? 'white' : getBackgroundColor();
    }
    if (props.noShadow || outLined)
        buttonStyle.boxShadow = 'none'
    if (outLined) {
        buttonStyle.border = '1px solid lightgrey';
    }
    if (props.center)
        buttonStyle.alignSelf = 'center'
    if (props.large) {
        buttonStyle.fontSize = '12.5pt';
        buttonStyle.height = '42px';
    }
    const onClick = async (e) => {
        if (props.disabled || isLoading)
            return;

        setIsLoading(true)
        //Send Tracking event
        console.log("ON CLICK")
        if (props.onClick) {
            e.stopPropagation();
            await props.onClick(e);
        }

        setIsLoading(false)
    }

    return (
        <div
            className={props.className ? props.className : `bt${props.color?'':' b-primary'} ${props.disabled?'b-disabled':''}`}
            {...props}
            style={{ ...buttonStyle, ...props.style }}
            onClick={onClick}
        >
            {isLoading ? [<LoadingOutlined />, <span style={{opacity:props.color==='white'?'0.65':1}}> &nbsp;&nbsp; </span>] : null}{props.children}
        </div>
    )
}